import React, { useEffect, useState } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { api_url } from "../../helpers/apiHelpers";
import { toast } from "react-toastify";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from "@headlessui/react";
import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";

const Uincometax = () => {
  const navigate = useNavigate();
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [selectedOffice, setSelectedOffice] = useState(null);
  const [EditEmpDialog, setEditEmpDialog] = useState(false);
  const [EditOfficeDialog, setEditOfficeDialog] = useState(false);
  const [pageLoad, setPageLoad] = useState(false);
  const userId = localStorage.getItem("userId");
  const adminName = localStorage.getItem("adminName");
  const [subDropdownOpen, setSubDropdownOpen] = useState(null); // Manage sub-dropdown states
  // Toggle sub-dropdown based on index
  const toggleSubDropdown = (index) => {
    setSubDropdownOpen((prev) => (prev === index ? null : index)); // Open the clicked dropdown and close others
  };

  const [activeTab, setActiveTab] = useState("office");

  const [query1, setQuery1] = useState("");
  const [query, setQuery] = useState("");
  // const navigate = useNavigate();

  const [officeData, setOfficeData] = useState([]);
  const [filterOfficeData, setFilterOfficeData] = useState([]);
  const getOfficeData = async () => {
    const response = await fetch(`${api_url}/api/users/all-office-data`, {
      method: "POST",
      body: JSON.stringify({
        userId,
      }),
      headers: {
        "Content-Type": "application/json",
      },
    });

    const result = await response.json();
    if (result.status === 201) {
      setOfficeData(result.result);
      setFilterOfficeData(result.result);
    }
  };

  const [allEmpData, setAllEmpData] = useState([]);
  const [filterEmpData, setFilterEmpsData] = useState([]);
  const getAllData = async () => {
    const response = await fetch(`${api_url}/api/users/get-users-employee`, {
      method: "POST",
      body: JSON.stringify({
        userId,
      }),
      headers: {
        "Content-Type": "application/json",
      },
    });

    const result = await response.json();
    if (result.status === 201) {
      setAllEmpData(result.result);
      setFilterEmpsData(result.result);
    }
  };

  useEffect(() => {
    getAllData();
    getOfficeData();
    setPageLoad(false);
  }, [pageLoad]);

  const [birthDate, setBirthDate] = useState(new Date());
  const [age, setAge] = useState("");
  const [gender, setGender] = useState("Male");
  const [cadre, setCadre] = useState("A");

  const [employeeInitial, setEmployeeInitial] = useState("Shri.");
  const [employeeName, setEmployeeName] = useState("");
  const [designation, setDesignation] = useState("");
  const [panNo, setPanNo] = useState("");
  const [aadharNo, setAadharNo] = useState("");
  const [payScale, setPayScale] = useState("");

  const [selectedOfficeId, setSelectedOfficeId] = useState();
  const [officeName, setOfficeName] = useState("");
  const [officeAddress, setOfficeAddress] = useState("");
  const [officerName, setOfficerName] = useState("");
  const [officerDesignation, setOfficerDesignation] = useState("");
  const [officeTanNo, setOfficeTanNo] = useState("");
  const [financialYear, setFinancialYear] = useState("2024-2025");
  const [assessmentYear, setAssessmentYear] = useState("2025-2026");

  const handleDateChange = (inputDate) => {
    // const inputDate = e; // yyyy-mm-dd format
    if (inputDate) {
      const formattedDate = formatDate(inputDate);
      setBirthDate(formattedDate);
    } else {
      setBirthDate("");
    }
  };

  const editEmployee = (id) => {
    setEditEmpDialog(true);
    const result = allEmpData.find((item) => item._id === id);
    const ofData = officeData.find(
      (items) => items.officeName === result.officeName
    );
    setSelectedOfficeId(ofData._id);
    setOfficeName(ofData.officeName);
    setBirthDate(result.dateOfBirth);
    setGender(result.gender);
    setEmployeeInitial(result.EmpInitial);
    setEmployeeName(result.EmpName);
    setDesignation(result.EmpDesignation);
    setPanNo(result.PANNo);
    setAadharNo(result.adharNo);
    setPayScale(result.payScale);
    setSelectedEmployee(result);
  };
  const editOffice = (id) => {
    setEditOfficeDialog(true);
    const ofData = officeData.find((item) => item._id === id);
    setSelectedOfficeId(ofData._id);
    setOfficeName(ofData.officeName);
    setOfficeAddress(ofData.officeAddress);
    setOfficerName(ofData.officerDDOName);
    setOfficerDesignation(ofData.officerDDODesignation);
    setOfficeTanNo(ofData.officerTANNo);
    setOfficeName(ofData.officeName);
    setFinancialYear(ofData.financialYear);
    setAssessmentYear(ofData.AssessmentYear);
    setSelectedOffice(ofData);
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, "0");
    const monthShort = date.toLocaleString("default", { month: "short" }); // e.g., Jan
    const year = date.getFullYear();
    return `${day}-${monthShort}-${year}`; // dd-mmm-yyyy
  };


  // Function to handle the selection of financial year
  const handleFinancialYearChange = (e) => {
    const selectedYear = e.target.value;
    setFinancialYear(selectedYear);

    // Automatically update assessment year based on financial year
    if (selectedYear) {
      const [startYear] = selectedYear.split("-");
      setAssessmentYear(
        `${parseInt(startYear) + 1}-${parseInt(startYear) + 2}`
      );
    } else {
      setAssessmentYear(""); // Reset if no financial year is selected
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (
        !employeeInitial ||
        !employeeName ||
        !designation ||
        !selectedOfficeId ||
        !birthDate ||
        !panNo ||
        !aadharNo ||
        !payScale
      ) {
        toast.error("Fill Mandatory Fields");
      } else {
        let ofData = officeData.find((item) => item._id === selectedOfficeId);

        const response = await fetch(`${api_url}/api/users/add-employee`, {
          method: "POST",
          body: JSON.stringify({
            officeData: ofData,
            employeeInitial,
            employeeName,
            designation,
            panNo,
            aadharNo,
            payScale,
            birthDate,
            age,
            gender,
            cadre,
            userId,
          }),
          headers: {
            "Content-Type": "application/json",
          },
        });

        const result = await response.json();
        if (result.status === 201) {
          toast.success(result.message);
          setPageLoad(true);
          setTimeout(() => {
            window.location.reload();
            navigate("/dashboard/user_incometax"); // Replace '/income-tax' with your actual route
          }, 1000); // Redirect after 2 seconds
        }
      }
    } catch (error) {
      toast.error("Something failed. Please try again.");
    }
  };
  const handleEmployeeEdit = async () => {
    let ofData = officeData.find((item) => item._id === selectedOfficeId);

    const response = await fetch(`${api_url}/api/users/update-employee`, {
      method: "POST",
      body: JSON.stringify({
        officeData: ofData,
        employeeInitial,
        employeeName,
        designation,
        panNo,
        aadharNo,
        payScale,
        birthDate,
        age,
        gender,
        cadre,
        userId,
        id: selectedEmployee._id,
      }),
      headers: {
        "Content-Type": "application/json",
      },
    });

    const result = await response.json();
    if (result.status === 201) {
      setEditEmpDialog(false);
      toast.success(result.message);
      setPageLoad(true);
      setTimeout(() => {
        window.location.reload();
        navigate("/dashboard/user_incometax"); // Replace '/income-tax' with your actual route
      }, 4000); // Redirect after 2 seconds
    } else {
      toast.error(result.message);
    }
  };

  const handleSubmitOfficeD = async () => {
    try {
      if (
        officeName === "" ||
        officeAddress === "" ||
        officerName === "" ||
        officerDesignation === "" ||
        officeTanNo === "" ||
        financialYear === ""
      ) {
        toast.error("Fill Mandatory Fields");
      } else {
        const response = await fetch(`${api_url}/api/users/add-office-data`, {
          method: "POST",
          body: JSON.stringify({
            officeName,
            officeAddress,
            officerName,
            officerDesignation,
            officeTanNo,
            financialYear,
            assessmentYear,
            userId,
          }),
          headers: {
            "Content-Type": "application/json",
          },
        });

        const result = await response.json();
        if (result.status === 201) {
          toast.success(result.message);
          setPageLoad(true);
          setTimeout(() => {
            window.location.reload();
            navigate("/dashboard/user_incometax"); // Replace '/income-tax' with your actual route
          }, 1000); // Redirect after 2 seconds
        } else {
          toast.error(result.message);
        }
      }
    } catch (error) {
      toast.error("Something failed. Please try again.");
    }
  };

  const handleEditOfficeD = async () => {
    try {
      const response = await fetch(`${api_url}/api/users/update-office-data`, {
        method: "POST",
        body: JSON.stringify({
          selectedOfficeId,
          officeName,
          officeAddress,
          officerName,
          officerDesignation,
          officeTanNo,
          financialYear,
          assessmentYear,
          userId,
        }),
        headers: {
          "Content-Type": "application/json",
        },
      });

      const result = await response.json();
      if (result.status === 201) {
        toast.success(result.message);
        setPageLoad(true);
        setTimeout(() => {
          window.location.reload();
          navigate("/dashboard/user_incometax"); // Replace '/income-tax' with your actual route
        }, 1000); // Redirect after 2 seconds
      } else {
        toast.error(result.message);
      }
    } catch (error) {
      toast.error("Something failed. Please try again.");
    }
  };

  const [errorMessage, setErrorMessage] = useState("");

  const validatePan = (value) => {
    // PAN format regex
    const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;

    if (!panRegex.test(value)) {
      setErrorMessage("Invalid PAN format. Must be in the format: AAAAA1234A");
    } else {
      setErrorMessage("");
    }
  };

  const handlePanChange = (e) => {
    const value = e.target.value.toUpperCase(); // Ensure uppercase input
    setPanNo(value);

    // Validate PAN
    if (value.length === 10) {
      validatePan(value);
    } else {
      setErrorMessage("PAN must be exactly 10 characters.");
    }
  };

  const [aadharErrorMessage, setAadharErrorMessage] = useState("");

  const formatAadharWithDashes = (value) => {
    // Remove all non-digit characters and format with dashes
    const numericValue = value.replace(/\D/g, "");
    const formattedValue =
      numericValue
        .match(/.{1,4}/g) // Group digits in chunks of 4
        ?.join("-") || ""; // Join groups with dashes
    return formattedValue;
  };

  const validateAadhar = (value) => {
    // Remove dashes for validation
    const numericValue = value.replace(/-/g, "");
    const aadharRegex = /^\d{12}$/;

    if (!aadharRegex.test(numericValue)) {
      setAadharErrorMessage(
        "Invalid Aadhar number. Must be exactly 12 digits."
      );
    } else {
      setAadharErrorMessage("");
    }
  };

  const handleAadharChange = (e) => {
    let value = e.target.value;

    // Format the input with dashes
    const formattedValue = formatAadharWithDashes(value);

    // Update state
    setAadharNo(formattedValue);

    // Validate when length is 12 (excluding dashes)
    const numericValue = formattedValue.replace(/-/g, "");
    if (numericValue.length === 12) {
      validateAadhar(formattedValue);
    } else {
      setAadharErrorMessage("");
    }
  };

  const officeDelete = async (id) => {
    const response = await fetch(`${api_url}/api/users/delete-office-data`, {
      method: "POST",
      body: JSON.stringify({
        id,
      }),
      headers: {
        "Content-Type": "application/json",
      },
    });

    const result = await response.json();
    if (result.status === 201) {
      setPageLoad(true);
      toast.success(result.message);
    } else {
      toast.error(result.message);
    }
  };

  const employeeDelete = async (id) => {
    const response = await fetch(`${api_url}/api/users/delete-users-employee`, {
      method: "POST",
      body: JSON.stringify({
        id,
      }),
      headers: {
        "Content-Type": "application/json",
      },
    });
    const result = await response.json();
    if (result.status === 201) {
      setPageLoad(true);
      toast.success(result.message);
    } else {
      toast.error(result.message);
    }
  };

  const handleFilterData = (query) => {
    const lowerCaseQuery = query.toLowerCase();
    const filteredItems = allEmpData.filter((admin) => {
      return (
        admin.EmpName.toLowerCase().includes(lowerCaseQuery) ||
        admin.EmpDesignation.toLowerCase().includes(lowerCaseQuery) ||
        admin.PANNo.toLowerCase().includes(lowerCaseQuery) ||
        admin.officeName.includes(lowerCaseQuery)
      );
    });

    setFilterEmpsData(filteredItems);
  };
  const handleFilterData2 = (query) => {
    const lowerCaseQuery = query.toLowerCase();
    const filteredItems = officeData.filter((admin) => {
      return (
        admin.officeName.toLowerCase().includes(lowerCaseQuery) ||
        admin.officeAddress.toLowerCase().includes(lowerCaseQuery) ||
        admin.officerDDOName.toLowerCase().includes(lowerCaseQuery) ||
        admin.officerDDODesignation.includes(lowerCaseQuery) ||
        admin.officerTANNo.includes(lowerCaseQuery)
      );
    });

    setFilterOfficeData(filteredItems);
  };

  return (
    <div className=" p-3 employee-details-page">
      <div className="row">
        <div className=" col-lg-12 text-end">
          <Link
            className="btn btn-primary btn-sm"
            to="#"
            data-bs-toggle="modal"
            data-bs-target="#exampleModal"
          >
            New Office
          </Link>
          <Link
            className="btn btn-primary ms-2 btn-sm"
            to="#"
            data-bs-toggle="modal"
            data-bs-target="#exampleModalEmployee"
          >
            New Employee
          </Link>
        </div>
        <div className=" col-lg-8 text-left"></div>
      </div>
      <ul class="nav nav-tabs mt-3 mt-lg-1" id="myTab" role="tablist">
        <li class="nav-item" role="presentation">
          <button
            class="fw-bold nav-link active"
            id="home-tab"
            data-bs-toggle="tab"
            data-bs-target="#home"
            type="button"
            role="tab"
            aria-controls="home"
            aria-selected="true"
          >
            All Employee
          </button>
        </li>
        <li class="nav-item" role="presentation">
          <button
            class="fw-bold nav-link"
            id="profile-tab"
            data-bs-toggle="tab"
            data-bs-target="#profile"
            type="button"
            role="tab"
            aria-controls="profile"
            aria-selected="false"
          >
            All Office
          </button>
        </li>
        <li class="nav-item" role="presentation">
          <Link
            class="fw-bold nav-link"
            // id="profile-tab"
            // data-bs-toggle="tab"
            // data-bs-target="#profile"
            type="button"
            to={"/dashboard/user_incometax_complete"}
            role="tab"
            // aria-controls="profile"
            // aria-selected="false"
          >
            Completed Work
          </Link>
        </li>
      </ul>
      <div class="tab-content pt-3" id="myTabContent">
        <div
          class="tab-pane fade show active"
          id="home"
          role="tabpanel"
          aria-labelledby="home-tab"
        >
          <div className="row">
            <div className=" col-lg-3 ms-auto">
              <div className="input-group mb-3">
                <span className="input-group-text" id="basic-addon1">
                  <i className="fas fa-search"></i>
                </span>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Employee Search Here..."
                  value={query}
                  onChange={(e) => {
                    setQuery(e.target.value);
                    handleFilterData(e.target.value);
                  }}
                />
              </div>
            </div>
            <div className=" col-lg-12 text-left overflow-auto">
              <table class="table table-bordered text-left">
                <thead>
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col">Date</th>
                    <th scope="col">Name</th>
                    <th scope="col">Designation</th>
                    <th scope="col">PAN No. </th>
                    <th scope="col">OfficeName</th>
                    <th scope="col">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {filterEmpData &&
                    filterEmpData.map((item, index) => (
                      <tr>
                        <th scope="row">{index + 1}</th>
                        <td scope="col">
                          {moment(item.createdAt).format("DD-MMM-YYYY")}
                        </td>
                        <td>
                          <Link
                            className="fw-bold text-primary"
                            to={`/dashboard/incometax_calcuation/${item._id}`}
                          >
                            {item.EmpName}
                          </Link>
                        </td>
                        <td>{item.EmpDesignation}</td>
                        <td>{item.PANNo}</td>
                        <td>{item.officeName}</td>
                        <td>
                          <button
                            className="btn btn-sm btn-outline-primary py-0 px-2"
                            onClick={() => editEmployee(item._id)}
                          >
                            <i className="fa fa-pencil"></i> Edit
                          </button>
                          {adminName && (
                            <button
                              className="btn btn-sm btn-outline-danger py-0 px-2 ms-2"
                              onClick={() => employeeDelete(item._id)}
                            >
                              <i className="fa fa-trash"></i>
                            </button>
                          )}
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div
          class="tab-pane fade"
          id="profile"
          role="tabpanel"
          aria-labelledby="profile-tab"
        >
          <div className="row">
            <div className=" col-lg-3 ms-auto">
              <div className="input-group mb-3">
                <span className="input-group-text" id="basic-addon1">
                  <i className="fas fa-search"></i>
                </span>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Office Search Here..."
                  value={query1}
                  onChange={(e) => {
                    setQuery1(e.target.value);
                    handleFilterData2(e.target.value);
                  }}
                />
              </div>
            </div>
            <div className=" col-lg-12 text-left  overflow-auto">
              <table class="table table-bordered text-left">
                <thead>
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col d-flex flex-nowrap">Office Name</th>
                    <th scope="col d-flex flex-nowrap">Office Address</th>
                    <th scope="col d-flex flex-nowrap">Officer Name</th>
                    <th scope="col d-flex flex-nowrap">Designation</th>
                    <th scope="col d-flex flex-nowrap">TAN No. </th>
                    <th scope="col">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {filterOfficeData &&
                    filterOfficeData.map((item, index) => (
                      <tr>
                        <th scope="row">{index + 1}</th>
                        <td>
                          <Link
                            className="fw-bold"
                            to={`/dashboard/incometax_calcuation/${item._id}`}
                          >
                            {item.officeName}
                          </Link>
                        </td>
                        <td>{item.officeAddress}</td>
                        <td>{item.officerDDOName}</td>
                        <td>{item.officerDDODesignation}</td>
                        <td>{item.officerTANNo}</td>

                        <td>
                          <button
                            className="btn btn-sm btn-outline-primary py-0 px-2"
                            onClick={() => editOffice(item._id)}
                          >
                            <i className="fa fa-pencil"></i> Edit
                          </button>
                          {adminName && (
                            <button
                              className="btn btn-sm btn-outline-danger py-0 px-2 ms-2"
                              onClick={() => officeDelete(item._id)}
                            >
                              <i className="fa fa-trash"></i>
                            </button>
                          )}
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <div
        class="modal fade"
        id="exampleModal"
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title fw-bold" id="exampleModalLabel">
                Add Office Information
              </h5>
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div class="modal-body text-start">
              <div className="flex flex-col md:flex-row gap-4 mb-3">
                <div className="flex-1">
                  <label
                    htmlFor="officeName"
                    className="block text-gray-700 mb-2"
                  >
                    Office Name
                  </label>
                  <input
                    type="text"
                    id="officeName"
                    name="officeName"
                    value={officeName}
                    onChange={(e) => setOfficeName(e.target.value)}
                    className="form-control"
                    required
                  />
                </div>
                <div className="flex-1">
                  <label
                    htmlFor="officeAddress"
                    className="block text-gray-700 mb-2"
                  >
                    Office Address
                  </label>
                  <input
                    type="text"
                    id="officeAddress"
                    name="officeAddress"
                    value={officeAddress}
                    onChange={(e) => setOfficeAddress(e.target.value)}
                    className="form-control"
                    required
                  />
                </div>
              </div>

              <div className="flex flex-col md:flex-row gap-4 mb-3">
                <div className="flex-1">
                  <label
                    htmlFor="officerName"
                    className="block text-gray-700 mb-2"
                  >
                    Officer / DDO Name
                  </label>
                  <input
                    type="text"
                    id="officerName"
                    name="officerName"
                    value={officerName}
                    onChange={(e) => setOfficerName(e.target.value)}
                    className="form-control"
                    required
                  />
                </div>
                <div className="flex-1">
                  <label
                    htmlFor="officerDesignation"
                    className="block text-gray-700 mb-2"
                  >
                    Officer / DDO Designation
                  </label>
                  <input
                    type="text"
                    id="officerDesignation"
                    name="officerDesignation"
                    value={officerDesignation}
                    onChange={(e) => setOfficerDesignation(e.target.value)}
                    className="form-control"
                    required
                  />
                </div>
              </div>

              <div className="flex flex-col md:flex-row gap-4 mb-3">
                {/* Office TAN No */}
                <div className="flex-1">
                  <label
                    htmlFor="officeTanNo"
                    className="block text-gray-700 mb-2"
                  >
                    Office TAN No
                  </label>
                  <input
                    type="text"
                    id="officeTanNo"
                    name="officeTanNo"
                    value={officeTanNo}
                    onChange={(e) => setOfficeTanNo(e.target.value)}
                    className="form-control"
                    required
                  />
                </div>

                {/* Financial Year */}
                <div className="flex-1">
                  <label
                    htmlFor="financialYear"
                    className="block text-gray-700 mb-2"
                  >
                    Financial Year
                  </label>
                  <select
                    id="financialYear"
                    name="financialYear"
                    value={financialYear}
                    onChange={handleFinancialYearChange}
                    className="form-control"
                    required
                  >
                    <option value="">Select Year</option>
                    <option value="2024-2025">2024-2025</option>
                    <option value="2023-2024">2023-2024</option>
                    <option value="2025-2026">2025-2026</option>
                    <option value="2026-2027">2026-2027</option>
                    <option value="2027-2028">2027-2028</option>
                    <option value="2028-2029">2028-2029</option>
                    <option value="2029-2030">2029-2030</option>
                  </select>
                </div>

                {/* Assessment Year */}
                <div className="flex-1">
                  <label
                    htmlFor="assessmentYear"
                    className="block text-gray-700 mb-2"
                  >
                    Assessment Year
                  </label>
                  <input
                    type="text"
                    id="assessmentYear"
                    name="assessmentYear"
                    value={assessmentYear ? assessmentYear : "2025-2026"}
                    className="form-control"
                    readOnly
                  />
                </div>
              </div>

              <div className="row">
                <div className="col-lg-4 m-auto">
                  <button
                    className={`px-4 py-2 w-100 rounded btn btn-primary`}
                    onClick={() => handleSubmitOfficeD()}
                  >
                    Add Office
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="modal fade"
        id="exampleModalEmployee"
        tabindex="-1"
        aria-labelledby="exampleModalEmployeeLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-lg">
          <div class="modal-content ">
            <div class="modal-header">
              <h5 class="modal-title fw-bold" id="exampleModalEmployeeLabel">
                Add Employee Information
              </h5>
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div class="modal-body text-start">
              <div className="row">
                <div className="col-lg-12">
                  <label>Select Office</label>
                  <select
                    onChange={(e) => setSelectedOfficeId(e.target.value)}
                    className="form-control form-select"
                    required
                  >
                    <option value={""}>Select Office</option>
                    {officeData &&
                      officeData.map((item) => (
                        <option value={item._id}>{item.officeName}</option>
                      ))}
                  </select>
                </div>
              </div>
              <div className="row mt-2">
                <div className="col-lg-3">
                  <label htmlFor="employeeInitial">Initial</label>
                  <select
                    id="employeeInitial"
                    name="employeeInitial"
                    value={employeeInitial}
                    onChange={(e) => setEmployeeInitial(e.target.value)}
                    className="form-control form-select"
                    required
                  >
                    <option value="Shri.">Shri.</option>
                    <option value="Smt.">Smt.</option>
                    <option value="Kum.">Kum.</option>
                  </select>
                </div>
                <div className="col-lg-5">
                  <label>Employee Name</label>
                  <input
                    type="text"
                    id="employeeName"
                    name="employeeName"
                    value={employeeName}
                    onChange={(e) => setEmployeeName(e.target.value)}
                    className="form-control"
                    required
                  />
                </div>
                <div className="col-lg-4">
                  <label>Designation</label>
                  <input
                    type="text"
                    id="designation"
                    name="designation"
                    value={designation}
                    onChange={(e) => setDesignation(e.target.value)}
                    className="form-control"
                    required
                  />
                </div>
              </div>
              <div className="row mt-2">
                <div className="col-lg-4">
                  <label>PAN No</label>
                  <input
                    type="text"
                    id="panNo"
                    name="panNo"
                    value={panNo}
                    onChange={handlePanChange}
                    className="form-control uppercase"
                    required
                  />
                  {errorMessage && (
                    <small className="text-danger">{errorMessage}</small>
                  )}
                </div>
                <div className="col-lg-4">
                  <label>Aadhar No</label>
                  <input
                    type="text"
                    id="aadharNo"
                    name="aadharNo"
                    value={aadharNo}
                    onChange={handleAadharChange}
                    className="form-control"
                    maxLength="14" // Allow up to 14 characters to accommodate dashes
                    required
                  />
                  {aadharErrorMessage && (
                    <small className="text-danger">{aadharErrorMessage}</small>
                  )}
                </div>
                <div className="col-lg-4">
                  <label>Date of Birth</label>
                  <DatePicker
                    selected={birthDate}
                    onChange={(date) => handleDateChange(date)}
                    dateFormat="dd-MMM-yyyy" // Built-in format for DD-MMM-YYYY
                    className="form-control"
                    showMonthDropdown // Enables month dropdown
                    showYearDropdown // Enables year dropdown
                    dropdownMode="select" // Allows selection instead of scrolling
                  />
                </div>
              </div>
              <div className="row mt-2">
                <div className="col-lg-4">
                  <label> Pay Scale</label>
                  <select
                    id="payScale"
                    name="payScale"
                    value={payScale}
                    onChange={(e) => setPayScale(e.target.value)}
                    className="form-control form-select"
                    required
                  >
                    <option value="">Select Pay Scale</option>
                    <option value="Fixed Pay">Fixed Pay</option>
                    <option value="S-1 : 15000-47600">S-1 : 15000-47600</option>
                    <option value="S-2 : 15300-48700">S-2 : 15300-48700</option>
                    <option value="S-3 : 16600-52400">S-3 : 16600-52400</option>
                    <option value="S-4 : 17100-54000">S-4 : 17100-54000</option>
                    <option value="S-5 : 18000-56900">S-5 : 18000-56900</option>
                    <option value="S-6 : 19900-63200">S-6 : 19900-63200</option>
                    <option value="S-7 : 21700-69100">S-7 : 21700-69100</option>
                    <option value="S-8 : 25500-81100">S-8 : 25500-81100</option>
                    <option value="S-9 : 26400-83600">S-9 : 26400-83600</option>
                    <option value="S-10 : 29200-92300">
                      S-10 : 29200-92300
                    </option>
                    <option value="S-11 : 30100-95100">
                      S-11 : 30100-95100
                    </option>
                    <option value="S-12 : 32000-101600">
                      S-12 : 32000-101600
                    </option>
                    <option value="S-13 : 35400-112400">
                      S-13 : 35400-112400
                    </option>
                    <option value="S-14 : 38600-122800">
                      S-14 : 38600-122800
                    </option>
                    <option value="S-15 : 41800-132300">
                      S-15 : 41800-132300
                    </option>
                    <option value="S-16 : 44900-142400">
                      S-16 : 44900-142400
                    </option>
                    <option value="S-17 : 47600-151100">
                      S-17 : 47600-151100
                    </option>
                    <option value="S-18 : 49100-155800">
                      S-18 : 49100-155800
                    </option>
                    <option value="S-19 : 55100-175100">
                      S-19 : 55100-175100
                    </option>
                    <option value="S-20 : 56100-177500">
                      S-20 : 56100-177500
                    </option>
                    <option value="S-21 : 57100-180800">
                      S-21 : 57100-180800
                    </option>
                    <option value="S-22 : 60000-190800">
                      S-22 : 60000-190800
                    </option>
                    <option value="S-23 : 67700-208700">
                      S-23 : 67700-208700
                    </option>
                    <option value="S-24 : 71100-211900">
                      S-24 : 71100-211900
                    </option>
                    <option value="S-25 : 78800-209200">
                      S-25 : 78800-209200
                    </option>
                    <option value="S-27 : 118500-214100">
                      S-27 : 118500-214100
                    </option>
                    <option value="S-28 : 124800-212400">
                      S-28 : 124800-212400
                    </option>
                    <option value="S-29 : 131100-216600">
                      S-29 : 131100-216600
                    </option>
                  </select>
                </div>

                <div className="col-lg-4">
                  <label>Gender</label>
                  <div className="flex items-center gap-4">
                    <div>
                      <input
                        type="radio"
                        id="male"
                        name="gender"
                        value="male"
                        className="mr-2"
                        onChange={() => setGender("Male")}
                      />
                      <label htmlFor="male" className="text-gray-700">
                        Male
                      </label>
                    </div>
                    <div>
                      <input
                        type="radio"
                        id="female"
                        name="gender"
                        value="female"
                        className="mr-2"
                        onChange={() => setGender("Female")}
                      />
                      <label htmlFor="female" className="text-gray-700">
                        Female
                      </label>
                    </div>
                  </div>
                </div>
              </div>

              <div className="mt-3 md:mt-6 text-center">
                <button
                  type="submit"
                  className="w-25 m-auto bg-blue-500 text-white font-bold py-2 px-4 rounded-md hover:bg-blue-600"
                  onClick={handleSubmit}
                >
                  Add Employee
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Dialog
        open={EditEmpDialog}
        onClose={setEditEmpDialog}
        className="employee-details-page relative z-10 w-100"
      >
        <DialogBackdrop
          transition
          className="fixed inset-0 bg-gray-500/75  transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
        />

        <div className=" fixed inset-0 z-10 w-screen overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <DialogPanel
              transition
              className=" relative transform p-5 overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
            >
              <h5 class="modal-title fw-bold" id="exampleModalEmployeeLabel">
                Edit Employee Information
              </h5>
              <hr />
              <div className="pt-4">
                <div className="row ">
                  <div className="col-lg-12">
                    <label>Select Office</label>
                    <select
                      onChange={(e) => setSelectedOfficeId(e.target.value)}
                      className="form-control form-select"
                      required
                    >
                      <option value={selectedOfficeId}>{officeName}</option>
                      {officeData &&
                        officeData.map((item) => (
                          <option value={item._id}>{item.officeName}</option>
                        ))}
                    </select>
                  </div>
                </div>
                <div className="row mt-2">
                  <div className="col-lg-3">
                    <label htmlFor="employeeInitial">Initial</label>
                    <select
                      id="employeeInitial"
                      name="employeeInitial"
                      value={employeeInitial}
                      onChange={(e) => setEmployeeInitial(e.target.value)}
                      className="form-control form-select"
                      required
                    >
                      <option value="Shri.">Shri.</option>
                      <option value="Smt.">Smt.</option>
                      <option value="Kum.">Kum.</option>
                    </select>
                  </div>
                  <div className="col-lg-5">
                    <label>Employee Name</label>
                    <input
                      type="text"
                      id="employeeName"
                      name="employeeName"
                      value={employeeName}
                      onChange={(e) => setEmployeeName(e.target.value)}
                      className="form-control"
                      required
                    />
                  </div>
                  <div className="col-lg-4">
                    <label>Designation</label>
                    <input
                      type="text"
                      id="designation"
                      name="designation"
                      value={designation}
                      onChange={(e) => setDesignation(e.target.value)}
                      className="form-control"
                      required
                    />
                  </div>
                </div>
                <div className="row mt-2">
                  <div className="col-lg-4">
                    <label>PAN No</label>
                    <input
                      type="text"
                      id="panNo"
                      name="panNo"
                      value={panNo}
                      onChange={handlePanChange}
                      className="form-control uppercase"
                      required
                    />
                    {errorMessage && (
                      <small className="text-danger">{errorMessage}</small>
                    )}
                  </div>
                  <div className="col-lg-4">
                    <label>Aadhar No</label>
                    <input
                      type="text"
                      id="aadharNo"
                      name="aadharNo"
                      value={aadharNo}
                      onChange={handleAadharChange}
                      className="form-control"
                      maxLength="14" // Allow up to 14 characters to accommodate dashes
                      required
                    />
                    {aadharErrorMessage && (
                      <small className="text-danger">
                        {aadharErrorMessage}
                      </small>
                    )}
                  </div>
                  <div className="col-lg-4">
                    <label>Date of Birth</label>
                    <DatePicker
                      selected={birthDate}
                      onChange={(date) => handleDateChange(date)}
                      dateFormat="dd-MMM-yyyy" // Built-in format for DD-MMM-YYYY
                      className="form-control"
                      showMonthDropdown // Enables month dropdown
                      showYearDropdown // Enables year dropdown
                      dropdownMode="select" // Allows selection instead of scrolling
                    />
                  </div>
                </div>
                <div className="row mt-2">
                  <div className="col-lg-6">
                    <label> Pay Scale</label>
                    <select
                      id="payScale"
                      name="payScale"
                      value={payScale}
                      onChange={(e) => setPayScale(e.target.value)}
                      className="form-control form-select"
                      required
                    >
                      <option
                        value={selectedEmployee && selectedEmployee.payScale}
                      >
                        {selectedEmployee && selectedEmployee.payScale}
                      </option>
                      <option value="Fixed Pay">Fixed Pay</option>
                      <option value="S-1 : 15000-47600">
                        S-1 : 15000-47600
                      </option>
                      <option value="S-2 : 15300-48700">
                        S-2 : 15300-48700
                      </option>
                      <option value="S-3 : 16600-52400">
                        S-3 : 16600-52400
                      </option>
                      <option value="S-4 : 17100-54000">
                        S-4 : 17100-54000
                      </option>
                      <option value="S-5 : 18000-56900">
                        S-5 : 18000-56900
                      </option>
                      <option value="S-6 : 19900-63200">
                        S-6 : 19900-63200
                      </option>
                      <option value="S-7 : 21700-69100">
                        S-7 : 21700-69100
                      </option>
                      <option value="S-8 : 25500-81100">
                        S-8 : 25500-81100
                      </option>
                      <option value="S-9 : 26400-83600">
                        S-9 : 26400-83600
                      </option>
                      <option value="S-10 : 29200-92300">
                        S-10 : 29200-92300
                      </option>
                      <option value="S-11 : 30100-95100">
                        S-11 : 30100-95100
                      </option>
                      <option value="S-12 : 32000-101600">
                        S-12 : 32000-101600
                      </option>
                      <option value="S-13 : 35400-112400">
                        S-13 : 35400-112400
                      </option>
                      <option value="S-14 : 38600-122800">
                        S-14 : 38600-122800
                      </option>
                      <option value="S-15 : 41800-132300">
                        S-15 : 41800-132300
                      </option>
                      <option value="S-16 : 44900-142400">
                        S-16 : 44900-142400
                      </option>
                      <option value="S-17 : 47600-151100">
                        S-17 : 47600-151100
                      </option>
                      <option value="S-18 : 49100-155800">
                        S-18 : 49100-155800
                      </option>
                      <option value="S-19 : 55100-175100">
                        S-19 : 55100-175100
                      </option>
                      <option value="S-20 : 56100-177500">
                        S-20 : 56100-177500
                      </option>
                      <option value="S-21 : 57100-180800">
                        S-21 : 57100-180800
                      </option>
                      <option value="S-22 : 60000-190800">
                        S-22 : 60000-190800
                      </option>
                      <option value="S-23 : 67700-208700">
                        S-23 : 67700-208700
                      </option>
                      <option value="S-24 : 71100-211900">
                        S-24 : 71100-211900
                      </option>
                      <option value="S-25 : 78800-209200">
                        S-25 : 78800-209200
                      </option>
                      <option value="S-27 : 118500-214100">
                        S-27 : 118500-214100
                      </option>
                      <option value="S-28 : 124800-212400">
                        S-28 : 124800-212400
                      </option>
                      <option value="S-29 : 131100-216600">
                        S-29 : 131100-216600
                      </option>
                    </select>
                  </div>

                  <div className="col-lg-6">
                    <label>Gender</label>
                    <div className="flex items-center gap-4">
                      <div>
                        <input
                          type="radio"
                          id="male"
                          name="gender"
                          value="male"
                          className="mr-2"
                          checked={
                            selectedEmployee &&
                            selectedEmployee.gender === "Male"
                          }
                          onChange={() => setGender("Male")}
                        />
                        <label htmlFor="male" className="text-gray-700">
                          Male
                        </label>
                      </div>
                      <div>
                        <input
                          type="radio"
                          id="female"
                          name="gender"
                          checked={
                            selectedEmployee &&
                            selectedEmployee.gender === "Female"
                          }
                          value="female"
                          className="mr-2"
                          onChange={() => setGender("Female")}
                        />
                        <label htmlFor="female" className="text-gray-700">
                          Female
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="gap-4 float-end">
                <button
                  type="submit"
                  className=" mt-3 ms-3 inline-flex w-full justify-center rounded-md bg-primary px-3 py-2 text-sm font-semibold text-white shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                  onClick={handleEmployeeEdit}
                >
                  Update Employee
                </button>
                <button
                  type="button"
                  data-autofocus
                  onClick={() => setEditEmpDialog(false)}
                  className="mt-3 ms-3 inline-flex w-full justify-center rounded-md bg-danger px-3 py-2 text-sm font-semibold text-white shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                >
                  Close
                </button>
              </div>
            </DialogPanel>
          </div>
        </div>
      </Dialog>

      <Dialog
        open={EditOfficeDialog}
        onClose={setEditOfficeDialog}
        className="relative z-10"
      >
        <DialogBackdrop
          transition
          className="fixed inset-0 bg-gray-500/75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
        />

        <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <DialogPanel
              transition
              className="relative transform p-3 overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
            >
              <h5 class="modal-title fw-bold" id="exampleModalEmployeeLabel">
                Edit Office Information
              </h5>
              <hr />
              <div className="flex flex-col md:flex-row gap-4 mb-3 mt-3">
                <div className="flex-1">
                  <label
                    htmlFor="officeName"
                    className="block text-gray-700 mb-2"
                  >
                    Office Name
                  </label>
                  <input
                    type="text"
                    id="officeName"
                    name="officeName"
                    value={officeName}
                    onChange={(e) => setOfficeName(e.target.value)}
                    className="form-control"
                    required
                  />
                </div>
                <div className="flex-1">
                  <label
                    htmlFor="officeAddress"
                    className="block text-gray-700 mb-2"
                  >
                    Office Address
                  </label>
                  <input
                    type="text"
                    id="officeAddress"
                    name="officeAddress"
                    value={officeAddress}
                    onChange={(e) => setOfficeAddress(e.target.value)}
                    className="form-control"
                    required
                  />
                </div>
              </div>

              <div className="flex flex-col md:flex-row gap-4 mb-3">
                <div className="flex-1">
                  <label
                    htmlFor="officerName"
                    className="block text-gray-700 mb-2"
                  >
                    Officer / DDO Name
                  </label>
                  <input
                    type="text"
                    id="officerName"
                    name="officerName"
                    value={officerName}
                    onChange={(e) => setOfficerName(e.target.value)}
                    className="form-control"
                    required
                  />
                </div>
                <div className="flex-1">
                  <label
                    htmlFor="officerDesignation"
                    className="block text-gray-700 mb-2"
                  >
                    Officer / DDO Designation
                  </label>
                  <input
                    type="text"
                    id="officerDesignation"
                    name="officerDesignation"
                    value={officerDesignation}
                    onChange={(e) => setOfficerDesignation(e.target.value)}
                    className="form-control"
                    required
                  />
                </div>
              </div>

              <div className="flex flex-col md:flex-row gap-4 mb-3">
                {/* Office TAN No */}
                <div className="flex-1">
                  <label
                    htmlFor="officeTanNo"
                    className="block text-gray-700 mb-2"
                  >
                    Office TAN No
                  </label>
                  <input
                    type="text"
                    id="officeTanNo"
                    name="officeTanNo"
                    value={officeTanNo}
                    onChange={(e) => setOfficeTanNo(e.target.value)}
                    className="form-control"
                    required
                  />
                </div>

                {/* Financial Year */}
                <div className="flex-1">
                  <label
                    htmlFor="financialYear"
                    className="block text-gray-700 mb-2"
                  >
                    Financial Year
                  </label>
                  <select
                    id="financialYear"
                    name="financialYear"
                    value={financialYear}
                    onChange={handleFinancialYearChange}
                    className="form-control"
                    required
                  >
                    <option value={financialYear}>{financialYear}</option>
                    <option value="2024-2025">2024-2025 </option>
                    <option value="2023-2024">2023-2024</option>
                    <option value="2025-2026">2025-2026</option>
                    <option value="2026-2027">2026-2027</option>
                    <option value="2027-2028">2027-2028</option>
                    <option value="2028-2029">2028-2029</option>
                    <option value="2029-2030">2029-2030</option>
                  </select>
                </div>

                {/* Assessment Year */}
                <div className="flex-1">
                  <label
                    htmlFor="assessmentYear"
                    className="block text-gray-700 mb-2"
                  >
                    Assessment Year
                  </label>
                  <input
                    type="text"
                    id="assessmentYear"
                    name="assessmentYear"
                    value={assessmentYear ? assessmentYear : "2025-2026"}
                    className="form-control"
                    readOnly
                  />
                </div>
              </div>

              <div className="gap-4 float-end">
                <button
                  className={`mt-3 ms-3 inline-flex w-full justify-center rounded-md bg-primary px-3 py-2 text-sm font-semibold text-white shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto`}
                  onClick={() => handleEditOfficeD()}
                >
                  Update Office
                </button>
                <button
                  type="button"
                  data-autofocus
                  onClick={() => setEditOfficeDialog(false)}
                  className="mt-3 ms-3 inline-flex w-full justify-center rounded-md bg-danger px-3 py-2 text-sm font-semibold text-white shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                >
                  Close
                </button>
              </div>
            </DialogPanel>
          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default Uincometax;
